@if (!breadcrumbData.isStoreFinderDetailsPage) {
  @if (!!breadcrumbData.breadcrumbs.length) {
    <boels-vertical-aligner
      [innerWidth]="'wide'"
      class="breadcrumbs__container"
    >
      <div class="breadcrumbs">
        <fa-icon
          class="breadcrumb__icon breadcrumb__icon--mobile"
          size="xs"
          [icon]="faChevronLeft"
        ></fa-icon>

        @for (
          breadcrumbItem of breadcrumbData.breadcrumbs;
          track breadcrumbItem;
          let index = $index;
          let isFirst = $first;
          let isLast = $last
        ) {
          @if (!isLast) {
            <boels-generic-link
              class="breadcrumb__link"
              [ngClass]="{
                'breadcrumb__link--mobile':
                  breadcrumbData.breadcrumbs.length > 2 &&
                  index === breadcrumbData.breadcrumbs.length - 2,
              }"
              [url]="breadcrumbItem.url"
            >
              {{
                isFirst
                  ? (breadcrumbItem.code | transloco)
                  : breadcrumbItem.name
              }}
            </boels-generic-link>

            <fa-icon
              class="breadcrumb__icon breadcrumb__icon--desktop"
              size="xs"
              [icon]="faChevronRight"
            ></fa-icon>
          }
          @if (isLast) {
            <span
              class="breadcrumb__link text-subtle-gray_1000"
              boelsQa="activeBreadcrumb"
            >
              {{ breadcrumbItem.name }}
            </span>
          }
        }
      </div>
    </boels-vertical-aligner>
  }
} @else {
  <boels-vertical-aligner [innerWidth]="'wide'" class="breadcrumbs__container">
    <span class="breadcrumb__back" (click)="goBack()">
      <fa-icon [icon]="faChevronLeft" size="xs"></fa-icon>
      {{ $backTextSub | async }}
    </span>
  </boels-vertical-aligner>
}
@if (breadcrumbData.title && !breadcrumbData.isStoreFinderDetailsPage) {
  <boels-vertical-aligner [innerWidth]="'wide'">
    <h1 class="h2">
      {{ breadcrumbData.title }}
    </h1>
  </boels-vertical-aligner>
}
